const linkResolver = (doc) => {
  if (doc.type === "case_study") return "/work/" + doc.uid + "/"
  if (doc.type === "home") return doc.uid + "/"
  if (doc.type === "journal") return doc.uid + "/"
  if (doc.type === "about") return doc.uid + "/"
  if (doc.type === "services") return doc.uid + "/"
  if (doc.type === "work") return doc.uid + "/"

  return "/"
}

module.exports = linkResolver
